const iconProfile = `
  <svg width="30" height="30" viewBox="-2 -2 34 34" xmlns="http://www.w3.org/2000/svg">
    <g fill="none">
      <path d="M0 0h30v30H0z"/>
      <g class="icon-color" fill="#038AB7">
        <path d="M14.665 15.502c2.798 0 5.067-2.239 5.067-5 0-2.763-2.269-5.002-5.067-5.002S9.6 7.74 9.6 10.501c0 2.762 2.268 5.001 5.066 5.001zm0 2.5c-4.197 0-7.599-3.358-7.599-7.5 0-4.144 3.402-7.502 7.6-7.502 4.196 0 7.599 3.358 7.599 7.501 0 4.143-3.403 7.501-7.6 7.501z"/>
        <path d="M24.798 28.004c0-5.524-4.537-10.002-10.133-10.002-5.595 0-10.132 4.478-10.132 10.002m-2.533 0C2 21.1 7.67 15.502 14.665 15.502c6.995 0 12.666 5.597 12.666 12.502"/>
      </g>
    </g>
  </svg>
`

export default iconProfile
